/** KAN-735: карточки статей расходов за месяц и итог в рублях. */
import { tokensAccountLine, tokensPartialLabel, tokensScopeLabel } from '@/lib/expensesTokens';
import { formatRub, formatUsd } from '@/lib/money';
import type { ExpenseItem } from '@/types/expenses';

interface Props {
  items: ExpenseItem[];
  totalRub: number;
}

/** Подпись под суммой: "3 шт. · в месяц", "$20.00", "$20.00 · по ключу платформы" (KAN-799). */
function itemDetails(item: ExpenseItem): string {
  const parts: string[] = [];
  if (typeof item.count === 'number') parts.push(`${item.count} шт.`);
  if (typeof item.amount_usd === 'number') parts.push(formatUsd(item.amount_usd));
  if (item.note) parts.push(item.note);
  const scopeLabel = tokensScopeLabel(item);
  if (scopeLabel) parts.push(scopeLabel);
  const partialLabel = tokensPartialLabel(item);
  if (partialLabel) parts.push(partialLabel);
  return parts.join(' · ');
}

export function ExpenseItemsCards({ items, totalRub }: Props): JSX.Element {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {items.map((item) => {
        const accountLine = tokensAccountLine(item);
        return (
          <div
            key={item.code}
            className="rounded-lg border bg-white p-4"
            data-testid={`expense-item-${item.code}`}
          >
            <p className="text-sm text-gray-500">{item.label}</p>
            <p className="mt-1 text-2xl font-semibold tabular-nums text-gray-900">
              {formatRub(item.amount_rub)}
            </p>
            <p className="mt-1 text-xs text-gray-500">{itemDetails(item)}</p>
            {accountLine && (
              <p
                className="mt-0.5 text-xs text-gray-400"
                data-testid={`expense-item-${item.code}-account`}
              >
                {accountLine}
              </p>
            )}
          </div>
        );
      })}
      <div className="rounded-lg border border-blue-200 bg-blue-50 p-4" data-testid="expenses-total">
        <p className="text-sm text-blue-800">Итого за месяц</p>
        <p className="mt-1 text-2xl font-semibold tabular-nums text-blue-900">
          {formatRub(totalRub)}
        </p>
      </div>
    </div>
  );
}
